// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractSimpleModuleUi } from '../_abstract/ui'

import { ParagraphModule } from './Paragraph.contracts'

/**
 * Component capable of rendering the `ParagraphModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'ParagraphModuleUi',
  template: '<component :is="component" class="paragraph-module" />'
})
export class ParagraphModuleUi extends AbstractSimpleModuleUi<ParagraphModule> {}
